/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url)
      ? " menu-item-active menu-item-open "
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>

        <li
          className={`menu-item ${getMenuItemActive("/percursos")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/percursos">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Route.svg")} />
            </span>
            <span className="menu-text">Percursos</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/filtros")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/filtros">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Filter.svg")} />
            </span>
            <span className="menu-text">Filtros</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/atributos")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/atributos">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Bookmark.svg")} />
            </span>
            <span className="menu-text">Atributos</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/feedback")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/feedback">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Chat1.svg")} />
            </span>
            <span className="menu-text">Feedback</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/reviews")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/reviews">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
            </span>
            <span className="menu-text">Reviews</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/informações")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/informações">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")} />
            </span>
            <span className="menu-text">Informações</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/patrocinadores")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/patrocinadores">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Dollar.svg")} />
            </span>
            <span className="menu-text">Patrocinadores</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/utilizadores")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/utilizadores">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")} />
            </span>
            <span className="menu-text">Utilizadores</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/termos-condicoes")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/termos-condicoes">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")} />
            </span>
            <span className="menu-text">Termos e Condições</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
